// DEMO ONLY. The turn shape every demo seed module builds its chats from.
import { SupportBlock } from '../../support/types';
import { OrbitTurn } from '../../types';

export interface IOrbitPageDemoChat {
  id: string;
  title: string;
  chips: string[];
  turns: OrbitTurn[];
}

const CREATED_AT = '2026-10-14T10:00:00+08:00';

let nextId = -100;

/** A completed turn carrying `blocks`, exactly as a live answer would; `''` draws no question. */
export const seedTurn = (question: string, blocks: SupportBlock[]): OrbitTurn => {
  nextId -= 1;
  return {
    id: nextId,
    session_id: 'orbit-page-demo',
    state: 'completed',
    outcome: 'answered',
    question,
    context: {},
    metric_results: [],
    answer: {},
    report_download_id: null,
    feedback: null,
    created_at: CREATED_AT,
    blocks
  };
};
